/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './folder-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-folder-list-page',
  template
})
export class FolderListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.dat-seg.folders.folder';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'folderId', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
